<template>
    <Badge lbl="mead.new" :color="color" />
</template>

<script>
import Badge from './Badge.vue';

/**
 * Small "New" tag marking recently released features
 */
export default {
    name: 'mead-new-badge',
    components: {Badge},
    props: {
        /**
         * Color of the badge: a COLOR_STYLES value, a tint of one or any CSS color. Defaults to a
         * slightly lighter primary
         */
        color: {type: String, default: 'highlight'},
    },
};
</script>
